import React, { useState } from 'react';
import {
  FaStar, FaArrowRight, FaFire, FaBolt, FaGem,
  FaCrown, FaLeaf, FaRegGem, FaEye, FaTimes,
  FaShippingFast, FaUndo, FaShieldAlt, FaSyncAlt,
  FaMapMarkerAlt, FaCube, FaUserCheck, FaTags,
  FaTruck, FaClock, FaExchangeAlt, FaQuestionCircle,
  FaCamera, FaHeart, FaChevronLeft, FaChevronRight,
  FaArrowLeft, FaBolt as FaLightning
} from 'react-icons/fa';

const ExclusiveCollection = () => {
  const [selectedItem, setSelectedItem] = useState(null);
  const [isRotating, setIsRotating] = useState(false);

  const handle360View = (e) => {
    e.stopPropagation();
    setIsRotating(true);
    setTimeout(() => setIsRotating(false), 2000);
  };

  const exclusiveItems = [
    {
      id: 1,
      name: 'BESTSELLER',
      tagline: 'German Engineering',
      image: "https://tse3.mm.bing.net/th/id/OIP.Z6aRkbc0FAU8mBfG-pJyRAHaDG?rs=1&pid=ImgDetMain",
      badge: 'PREMIUM',
      price: 2999,
      originalPrice: 4999,
      rating: 4.8,
      reviews: 1696,
      nearbyStores: 12,
      has360: true,
      hasTryOn: true,
      frameColors: ['Black', 'Gold', 'Silver'],
      frameSizes: ['S', 'M', 'L'],
      expressDelivery: true,
      warranty: '2 Years',
      exchange: '30 Days',
      description: 'Precision‑engineered frames with premium acetate and stainless steel hinges.',
      icon: <FaGem className="text-amber-500" />,
      bgColor: 'bg-amber-50',
      borderColor: 'border-amber-200',
      textColor: 'text-amber-600',
      gradient: 'from-amber-500 to-amber-600'
    },
    {
      id: 2,
      name: 'MAGNETIC CHARMS',
      tagline: 'Magnetic Magic',
      image: 'https://static.vecteezy.com/system/resources/previews/020/221/634/large_2x/1092-black-eyeglasses-isolated-on-a-transparent-background-photo.jpg',
      badge: 'MAGNETIC',
      price: 1999,
      originalPrice: 3500,
      rating: 4.5,
      reviews: 850,
      nearbyStores: 8,
      has360: false,
      hasTryOn: true,
      frameColors: ['Matte Black', 'Gunmetal'],
      frameSizes: ['M', 'L'],
      expressDelivery: false,
      warranty: '1 Year',
      exchange: '14 Days',
      description: 'Magnetic clip‑ons that instantly transform your look.',
      icon: <FaBolt className="text-blue-500" />,
      bgColor: 'bg-blue-50',
      borderColor: 'border-blue-200',
      textColor: 'text-blue-600',
      gradient: 'from-blue-500 to-blue-600'
    },
    {
      id: 3,
      name: 'PREMIUM EYEWEAR',
      tagline: 'Luxury Redefined',
      image: 'https://tse3.mm.bing.net/th/id/OIP.wWdDbR3XF5azr0hSmzBASQHaHa?rs=1&pid=ImgDetMain',
      badge: 'LUXURY',
      price: 4999,
      originalPrice: 7999,
      rating: 4.9,
      reviews: 2100,
      nearbyStores: 5,
      has360: true,
      hasTryOn: true,
      frameColors: ['Rose Gold', 'Champagne', 'Platinum'],
      frameSizes: ['S', 'M'],
      expressDelivery: true,
      warranty: '3 Years',
      exchange: '45 Days',
      description: 'Handcrafted titanium frames with Swarovski crystal accents.',
      icon: <FaCrown className="text-purple-500" />,
      bgColor: 'bg-purple-50',
      borderColor: 'border-purple-200',
      textColor: 'text-purple-600',
      gradient: 'from-purple-500 to-purple-600'
    },
    {
      id: 4,
      name: '2 IN 1: EYE+SUN',
      tagline: '2-in-1 Magic',
      image: 'https://tse2.mm.bing.net/th/id/OIP.uWJDHovoUh4AhxqNuAL9xgHaHa?rs=1&pid=ImgDetMain',
      badge: 'SWITCH',
      price: 3499,
      originalPrice: 5999,
      rating: 4.7,
      reviews: 1240,
      nearbyStores: 15,
      has360: true,
      hasTryOn: false,
      frameColors: ['Black/Blue', 'Tortoise/Gold'],
      frameSizes: ['M', 'L'],
      expressDelivery: true,
      warranty: '2 Years',
      exchange: '21 Days',
      description: 'Magnetic switch technology – clear to sun in a snap.',
      icon: <FaFire className="text-orange-500" />,
      bgColor: 'bg-orange-50',
      borderColor: 'border-orange-200',
      textColor: 'text-orange-600',
      gradient: 'from-orange-500 to-orange-600'
    },
    {
      id: 5,
      name: 'FEATHER TOUCH',
      tagline: 'Light as Air',
      image: 'https://d26qov2vs4lxs.cloudfront.net/glasses/product-uploads/rm0247/pro_1_tint.jpg',
      badge: 'LIGHT',
      price: 2499,
      originalPrice: 3999,
      rating: 4.6,
      reviews: 930,
      nearbyStores: 6,
      has360: false,
      hasTryOn: true,
      frameColors: ['Teal', 'Coral', 'Lavender'],
      frameSizes: ['S', 'M'],
      expressDelivery: false,
      warranty: '1 Year',
      exchange: '14 Days',
      description: 'Ultra‑lightweight TR90 frames for all‑day comfort.',
      icon: <FaLeaf className="text-green-500" />,
      bgColor: 'bg-green-50',
      borderColor: 'border-green-200',
      textColor: 'text-green-600',
      gradient: 'from-green-500 to-green-600'
    },
    {
      id: 6,
      name: 'CRYSTAL CLEAR',
      tagline: 'Crystal Vision',
      image: 'https://tse1.mm.bing.net/th/id/OIP.DVBebsCuRS8Skw4hj5sLxgHaDt?rs=1&pid=ImgDetMain',
      badge: 'TRENDY',
      price: 1499,
      originalPrice: 2499,
      rating: 4.4,
      reviews: 1560,
      nearbyStores: 20,
      has360: true,
      hasTryOn: true,
      frameColors: ['Clear', 'Smoke', 'Blue'],
      frameSizes: ['S', 'M', 'L'],
      expressDelivery: true,
      warranty: '1 Year',
      exchange: '14 Days',
      description: 'Modern clear acetate frames that suit any style.',
      icon: <FaRegGem className="text-pink-500" />,
      bgColor: 'bg-pink-50',
      borderColor: 'border-pink-200',
      textColor: 'text-pink-600',
      gradient: 'from-pink-500 to-pink-600'
    }
  ];

  if (selectedItem) {
    return (
      <ProductDetailPage
        item={selectedItem}
        onBack={() => setSelectedItem(null)}
        isRotating={isRotating}
        handle360View={handle360View}
      />
    );
  }

  return (
    <section className="py-16 bg-white min-h-screen">
      <div className="max-w-7xl mx-auto px-4">
        <div className="text-center mb-12">
          <h2 className="text-4xl font-black text-gray-900 mb-2 italic">OUR EXCLUSIVE RANGE</h2>
          <div className="h-1 w-20 bg-orange-500 mx-auto rounded-full"></div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {exclusiveItems.map((item) => (
            <div
              key={item.id}
              onClick={() => setSelectedItem(item)}
              className="group cursor-pointer"
            >
              <div className={`${item.bgColor} border ${item.borderColor} rounded-3xl p-4 transition-all duration-300 hover:shadow-2xl hover:scale-[1.02]`}>
                <div className="relative h-56 bg-white rounded-2xl overflow-hidden flex items-center justify-center">
                  <img src={item.image} alt={item.name} className="w-full h-full object-contain p-6 group-hover:scale-110 transition-transform duration-500" />
                  <div className="absolute inset-0 bg-black/5 opacity-0 group-hover:opacity-100 flex items-center justify-center transition-opacity">
                    <span className="bg-white/90 backdrop-blur px-4 py-2 rounded-full font-bold text-xs flex items-center gap-2 shadow-lg">
                      <FaEye /> QUICK VIEW
                    </span>
                  </div>
                  <span className={`absolute top-3 right-3 text-[10px] font-black px-3 py-1 rounded-full text-white bg-gradient-to-r ${item.gradient} shadow-md`}>
                    {item.badge}
                  </span>
                </div>
                <div className="mt-4 px-2">
                  <div className="flex justify-between items-start">
                    <div>
                      <h3 className="font-bold text-gray-900">{item.name}</h3>
                      <p className="text-xs text-gray-500">{item.tagline}</p>
                    </div>
                    <div className="text-right">
                      <p className="font-black text-xl text-gray-900">₹{item.price}</p>
                      <p className="text-[10px] text-gray-400 line-through">₹{item.originalPrice}</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

const ProductDetailPage = ({ item, onBack, isRotating, handle360View }) => {
  const [pincode, setPincode] = useState('');
  const [deliveryMessage, setDeliveryMessage] = useState('');
  const [selectedColor, setSelectedColor] = useState(item.frameColors[0]);
  const [selectedSize, setSelectedSize] = useState(item.frameSizes[1] || item.frameSizes[0]);
  const [activeTab, setActiveTab] = useState('highlights');
  const [selectedImageIndex, setSelectedImageIndex] = useState(0);

  const productImages = [
    item.image,
    'https://via.placeholder.com/400x300?text=Angle+2',
  ];

  const similarProducts = [
    {
      id: 101,
      name: 'Vincent Chase (On Sale)',
      image: 'https://cdn.pixabay.com/photo/2017/08/06/03/17/eyeglasses-2588234_1280.jpg',
      price: 800,
      originalPrice: 2000,
      discount: 60,
      uvProtection: false,
      powerAvailable: true,
    },
    {
      id: 102,
      name: 'Vincent Chase Polarized',
      image: 'https://tse2.mm.bing.net/th/id/OIP.7svET0AnUjNVi1pb7m9X0gHaE8?rs=1&pid=ImgDetMain&o=7&rm=3',
      price: 1200,
      originalPrice: 2000,
      discount: 40,
      uvProtection: true,
      powerAvailable: false,
    },
    {
      id: 103,
      name: 'Vincent Chase Polarized',
      image: 'https://img.freepik.com/premium-photo/eyeglasses-lens_1134901-351882.jpg',
      price: 1200,
      originalPrice: 2000,
      discount: 40,
      uvProtection: true,
      powerAvailable: true,
    },
  ];

  const reviews = {
    average: item.rating,
    total: item.reviews,
    breakdown: { 5: 89, 4: 9, 3: 2, 2: 0, 1: 0 },
    userPhotos: 10,
    recent: [
      { name: 'Yash A.', date: '27 Feb 2026', rating: 5, comment: 'awesome frame' },
      { name: 'sukhjinder s.', date: '27 Feb 2026', rating: 5, comment: 'Gggggggg' },
      { name: 'Deepshikha S.', date: '27 Feb 2026', rating: 5, comment: 'good fitting' },
      { name: 'Prasad D.', date: '27 Feb 2026', rating: 5, comment: 'light weight, super cool' },
      { name: 'Akhilesh J.', date: '27 Feb 2026', rating: 4, comment: 'nice fit' },
    ],
  };

  const faqs = [
    { q: 'What is the return policy?', a: 'We offer 30-day returns on all unused products.' },
    { q: 'Are these prescription compatible?', a: 'Yes, these frames can be fitted with prescription lenses.' },
  ];

  const lookCategories = [
    'Trending', 'Styling Ideas', 'Sea it through', 'Casual & Comfy',
    'Outdoorsy & Fun', 'Street Smart', 'Go Tripping', 'Recently Viewed',
  ];

  const shopByLooks = ['#bikerlook', '#dailywear', '#sharpandsleek', '#partynight'];

  const checkPincode = (e) => {
    e.stopPropagation();
    if (pincode.length === 6) {
      setDeliveryMessage('Express delivery available ');
    } else {
      setDeliveryMessage('Please enter a valid 6-digit pincode');
    }
  };

  const nextImage = (e) => {
    e.stopPropagation();
    setSelectedImageIndex((prev) => (prev + 1) % productImages.length);
  };
  const prevImage = (e) => {
    e.stopPropagation();
    setSelectedImageIndex((prev) => (prev - 1 + productImages.length) % productImages.length);
  };

  const discountPercent = Math.round(((item.originalPrice - item.price) / item.originalPrice) * 100);

  return (
    <div className="min-h-screen bg-white">
      <div className="sticky top-0 z-10 bg-white border-b border-gray-200 py-4 px-6 flex items-center">
        <button
          onClick={onBack}
          className="flex items-center gap-2 text-gray-600 hover:text-orange-500 transition-colors"
        >
          <FaArrowLeft /> Back to Collection
        </button>
      </div>

      <div className="max-w-7xl mx-auto px-4 py-8">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8">
          <div>
            <div className="relative bg-gray-50 rounded-3xl p-6 mb-6 border border-gray-200">
              <div className="relative h-64 md:h-80 flex items-center justify-center">
                <img
                  src={productImages[selectedImageIndex]}
                  alt="product"
                  className={`max-h-full max-w-full object-contain transition-transform duration-1000 ${isRotating ? 'rotate-y-360' : ''}`}
                />
                {isRotating && (
                  <div className="absolute inset-0 flex items-center justify-center pointer-events-none">
                    <div className="w-full h-1 bg-orange-500/40 animate-scan"></div>
                  </div>
                )}
              </div>
              <button onClick={prevImage} className="absolute left-2 top-1/2 -translate-y-1/2 bg-white/80 hover:bg-white rounded-full p-2 shadow-md">
                <FaChevronLeft className="text-gray-600" />
              </button>
              <button onClick={nextImage} className="absolute right-2 top-1/2 -translate-y-1/2 bg-white/80 hover:bg-white rounded-full p-2 shadow-md">
                <FaChevronRight className="text-gray-600" />
              </button>
              <div className="flex gap-2 mt-4 overflow-x-auto pb-2">
                {productImages.map((img, idx) => (
                  <button
                    key={idx}
                    onClick={(e) => { e.stopPropagation(); setSelectedImageIndex(idx); }}
                    className={`w-16 h-16 flex-shrink-0 rounded-lg border-2 overflow-hidden transition-all ${
                      idx === selectedImageIndex ? 'border-orange-500 scale-105' : 'border-transparent'
                    }`}
                  >
                  </button>
                ))}
              </div>
            </div>
            <div className="flex flex-wrap gap-3 mb-6">
              {item.has360 && (
                <button
                  onClick={handle360View}
                  className={`flex items-center gap-2 px-5 py-2.5 rounded-full border-2 font-bold text-sm transition-all ${
                    isRotating ? 'bg-orange-500 text-white border-orange-500' : 'bg-white border-gray-200 hover:border-orange-500'
                  }`}
                >
                  <FaSyncAlt className={isRotating ? 'animate-spin' : ''} /> 360° VIEW
                </button>
              )}
              {item.hasTryOn && (
                <button className="flex items-center gap-2 px-5 py-2.5 rounded-full bg-white border-2 border-gray-200 font-bold text-sm hover:border-blue-500">
                  <FaUserCheck /> TRY ON
                </button>
              )}
            </div>
            <div className="bg-blue-50 border border-blue-200 rounded-xl p-4 mb-6">
              <h3 className="font-semibold text-gray-800 mb-2 flex items-center gap-2">
                <FaQuestionCircle className="text-blue-500" /> How to Buy Your Glasses
              </h3>
              <p className="text-sm text-gray-600">Choose your frame, add prescription (if needed), and checkout. Our opticians will verify your details.</p>
            </div>
            <div className="mb-6">
              <h3 className="font-semibold text-gray-800 mb-3">Get Inspired with looks</h3>
              <div className="flex flex-wrap gap-2">
                {lookCategories.map((cat) => (
                  <span key={cat} className="bg-gray-100 text-gray-700 px-3 py-1.5 rounded-full text-xs hover:bg-orange-100 cursor-pointer transition-colors">
                    {cat}
                  </span>
                ))}
              </div>
            </div>
            <div className="mb-6">
              <h3 className="font-semibold text-gray-800 mb-3">Similar Products</h3>
              <div className="flex gap-4 overflow-x-auto pb-4">
                {similarProducts.map((prod) => (
                  <div key={prod.id} className="min-w-[180px] bg-white border border-gray-200 rounded-xl p-3 shadow-sm hover:shadow-lg transition-all">
                    <img src={prod.image} alt={prod.name} className="w-full h-24 object-contain mb-2" />
                    <h4 className="text-sm font-medium text-gray-800">{prod.name}</h4>
                    {prod.powerAvailable && <span className="text-xs text-green-600">Available in Power</span>}
                    <div className="flex items-baseline gap-2 mt-1">
                      <span className="text-lg font-bold text-gray-800">₹{prod.price}</span>
                      <span className="text-xs text-gray-400 line-through">₹{prod.originalPrice}</span>
                    </div>
                    <div className="text-xs text-green-600 font-semibold">{prod.discount}% OFF</div>
                    {prod.uvProtection && <div className="text-xs text-gray-500 mt-1">with 100% UV Protection</div>}
                    <button className="mt-2 w-full bg-gradient-to-r from-orange-500 to-orange-600 text-white text-xs py-2 rounded-full hover:from-orange-600 hover:to-orange-700 transform hover:scale-105 transition-all duration-300 shadow-md hover:shadow-lg">
                      View
                    </button>
                  </div>
                ))}
              </div>
            </div>
          </div>
          <div>
            <div className="flex flex-wrap items-center gap-3 mb-4">
              <div className="flex items-center bg-green-100 text-green-800 px-2 py-1 rounded-md text-sm">
                <FaStar className="text-yellow-500 mr-1" /> {item.rating}
              </div>
              <span className="text-gray-600 text-sm">{item.reviews.toLocaleString()} Reviews</span>
              <span className="text-gray-300">|</span>
              <span className="text-sm text-gray-600 flex items-center gap-1">
                <FaMapMarkerAlt className="text-gray-400" /> {item.nearbyStores} Nearby Stores
              </span>
              <div className="flex gap-2 ml-auto">
                {item.has360 && (
                  <span className="flex items-center gap-1 text-xs bg-gray-100 px-3 py-1.5 rounded-full">
                    <FaCube /> 360°
                  </span>
                )}
                {item.hasTryOn && (
                  <span className="flex items-center gap-1 text-xs bg-gray-100 px-3 py-1.5 rounded-full">
                    <FaUserCheck /> Try on
                  </span>
                )}
                <span className="flex items-center gap-1 text-xs bg-gray-100 px-3 py-1.5 rounded-full">
                  <FaTags /> Similar
                </span>
              </div>
            </div>
            <h2 className="text-3xl md:text-4xl font-black text-gray-900 mb-4">{item.name}</h2>
            <div className="mb-6">
              <div className="flex items-baseline gap-4">
                <span className="text-4xl font-black">₹{item.price}</span>
                <span className="text-xl text-gray-400 line-through">₹{item.originalPrice}</span>
                <span className="bg-orange-100 text-orange-600 px-3 py-1 rounded-lg font-bold">{discountPercent}% OFF</span>
              </div>
              <p className="text-orange-600 font-bold text-sm mt-2 uppercase tracking-tighter">Use code: SINGLE to get this price</p>
              <p className="text-xs text-gray-500 mt-1">with 100% UV Protection</p>
            </div>
            <div className="mb-4">
              <div className="flex items-center justify-between">
                <h4 className="text-sm font-semibold text-gray-700">Frame Color</h4>
                <span className="text-xs text-red-500">Few Left</span>
              </div>
              <div className="flex flex-wrap gap-2 mt-2">
                {item.frameColors.map((color) => (
                  <button
                    key={color}
                    onClick={(e) => { e.stopPropagation(); setSelectedColor(color); }}
                    className={`px-4 py-2 rounded-full text-sm border transition-all ${
                      selectedColor === color
                        ? 'bg-orange-500 text-white border-orange-500 shadow-md'
                        : 'bg-white text-gray-700 border-gray-300 hover:border-orange-500'
                    }`}
                  >
                    {color}
                  </button>
                ))}
              </div>
            </div>
            <div className="mb-4">
              <h4 className="text-sm font-semibold text-gray-700">Frame Size</h4>
              <div className="flex flex-wrap gap-2 mt-2">
                {item.frameSizes.map((size) => (
                  <button
                    key={size}
                    onClick={(e) => { e.stopPropagation(); setSelectedSize(size); }}
                    className={`px-4 py-2 rounded-full text-sm border transition-all ${
                      selectedSize === size
                        ? 'bg-orange-500 text-white border-orange-500 shadow-md'
                        : 'bg-white text-gray-700 border-gray-300 hover:border-orange-500'
                    }`}
                  >
                    {size}
                  </button>
                ))}
              </div>
            </div>
            <div className="mb-6">
              <h4 className="text-sm font-semibold text-gray-700 mb-2">Delivery Details</h4>
              <div className="flex gap-2">
                <input
                  type="text"
                  placeholder="Enter pincode"
                  value={pincode}
                  onChange={(e) => setPincode(e.target.value.replace(/\D/g, '').slice(0, 6))}
                  className="border border-gray-300 rounded-lg px-3 py-2 text-sm w-32 focus:outline-none focus:ring-2 focus:ring-orange-300"
                  onClick={(e) => e.stopPropagation()}
                />
                <button
                  onClick={checkPincode}
                  className="bg-orange-500 text-white px-4 py-2 rounded-lg text-sm hover:bg-orange-600 transition-colors"
                >
                  Check
                </button>
              </div>
              {deliveryMessage && (
                <p className="text-xs mt-2 text-gray-600 flex items-center gap-1">
                  <FaClock /> {deliveryMessage}
                </p>
              )}
              {item.expressDelivery && (
                <p className="text-xs mt-1 text-green-600 flex items-center gap-1">
                  <FaTruck /> Express delivery might be applicable
                </p>
              )}
            </div>
            <div className="grid grid-cols-3 gap-3 pt-4 border-t border-gray-200 mb-6">
              <div className="text-center">
                <div className="bg-gray-100 w-10 h-10 rounded-full flex items-center justify-center mx-auto mb-1">
                  <FaShieldAlt className="text-gray-600" />
                </div>
                <span className="text-xs text-gray-600">No questions asked</span>
              </div>
              <div className="text-center">
                <div className="bg-gray-100 w-10 h-10 rounded-full flex items-center justify-center mx-auto mb-1">
                  <FaExchangeAlt className="text-gray-600" />
                </div>
                <span className="text-xs text-gray-600">{item.exchange} exchange</span>
              </div>
              <div className="text-center">
                <div className="bg-gray-100 w-10 h-10 rounded-full flex items-center justify-center mx-auto mb-1">
                  <FaClock className="text-gray-600" />
                </div>
                <span className="text-xs text-gray-600">{item.warranty} warranty</span>
              </div>
            </div>
            <div className="mb-6">
              <div className="flex border-b border-gray-200 overflow-x-auto">
                {['highlights', 'details', 'reviews', 'faq'].map((tab) => (
                  <button
                    key={tab}
                    onClick={(e) => { e.stopPropagation(); setActiveTab(tab); }}
                    className={`px-4 py-2 text-sm font-medium capitalize whitespace-nowrap transition-colors ${
                      activeTab === tab
                        ? 'text-orange-500 border-b-2 border-orange-500'
                        : 'text-gray-500 hover:text-gray-700'
                    }`}
                  >
                    {tab === 'reviews' ? `Reviews (${item.reviews})` : tab}
                  </button>
                ))}
              </div>

              <div className="mt-4">
                {activeTab === 'highlights' && (
                  <div className="animate-fadeIn">
                    <h4 className="font-semibold text-gray-800 mb-2">Product Highlights</h4>
                    <ul className="grid grid-cols-2 gap-2 text-sm text-gray-600">
                      <li><span className="font-medium">New</span> Collection</li>
                      <li><span className="font-medium">Material:</span> Acetate</li>
                      <li><span className="font-medium">Hinge:</span> Spring</li>
                      <li><span className="font-medium">Temple:</span> Metal Core</li>
                      <li><span className="font-medium">Nosepad:</span> Adjustable</li>
                    </ul>
                  </div>
                )}
                {activeTab === 'details' && (
                  <div className="animate-fadeIn">
                    <h4 className="font-semibold text-gray-800 mb-2">Product Details</h4>
                    <p className="text-sm text-gray-600">{item.description}</p>
                    <p className="text-sm text-gray-600 mt-2">Frame width: 140mm • Lens width: 52mm • Bridge: 18mm • Temple length: 145mm</p>
                  </div>
                )}
                {activeTab === 'reviews' && (
                  <div className="animate-fadeIn">
                    <div className="bg-gradient-to-br from-orange-50 to-amber-50 rounded-2xl p-6 mb-6 shadow-sm border border-orange-100">
                      <div className="flex flex-col md:flex-row items-center gap-8">
                        <div className="text-center">
                          <div className="text-5xl font-black text-gray-800">{reviews.average}</div>
                          <div className="flex justify-center mt-2 gap-1">
                            {[1, 2, 3, 4, 5].map((star) => (
                              <FaStar
                                key={star}
                                className={`${
                                  star <= Math.round(reviews.average)
                                    ? 'text-yellow-400 drop-shadow-lg'
                                    : 'text-gray-300'
                                } text-xl transition-transform hover:scale-110 duration-200`}
                              />
                            ))}
                          </div>
                          <div className="text-sm text-gray-500 mt-1 font-medium">
                            {reviews.total.toLocaleString()} Reviews
                          </div>
                        </div>

                        <div className="flex-1 w-full space-y-2">
                          {[5, 4, 3, 2, 1].map((star) => (
                            <div key={star} className="flex items-center gap-3 text-sm">
                              <span className="w-12 font-semibold text-gray-600">{star} ★</span>
                              <div className="flex-1 h-2.5 bg-gray-200 rounded-full overflow-hidden">
                                <div
                                  className="h-full bg-gradient-to-r from-yellow-400 to-orange-400 rounded-full transition-all duration-1000 ease-out"
                                  style={{ width: `${reviews.breakdown[star]}%` }}
                                />
                              </div>
                              <span className="w-12 text-right font-medium text-gray-700">
                                {reviews.breakdown[star]}%
                              </span>
                            </div>
                          ))}
                        </div>
                      </div>
                    </div>
                    <div className="mb-6">
                      <h5 className="text-sm font-semibold text-gray-700 mb-3 flex items-center gap-2">
                        <FaCamera className="text-orange-500" /> User Photos ⸱ {reviews.userPhotos}
                      </h5>
                      <div className="flex gap-3 overflow-x-auto pb-2">
                        {[...Array(8)].map((_, i) => (
                          <div
                            key={i}
                            className="w-20 h-20 bg-gradient-to-br from-gray-100 to-gray-200 rounded-xl flex-shrink-0 border-2 border-white shadow-md hover:scale-105 transition-transform duration-300"
                          />
                        ))}
                        <div className="w-20 h-20 bg-orange-100 rounded-xl flex items-center justify-center text-xs font-bold text-orange-600 flex-shrink-0 border-2 border-orange-200 shadow-md hover:bg-orange-200 transition-colors">
                          +2
                        </div>
                      </div>
                    </div>
                    <div>
                      <h5 className="text-sm font-semibold text-gray-700 mb-3">Recent Reviews</h5>
                      <div className="space-y-4 max-h-80 overflow-y-auto pr-2">
                        {reviews.recent.map((rev, idx) => (
                          <div
                            key={idx}
                            className="bg-white border border-gray-100 rounded-xl p-4 shadow-sm hover:shadow-md transition-shadow"
                          >
                            <div className="flex items-center justify-between mb-2">
                              <span className="font-semibold text-gray-800">{rev.name}</span>
                              <span className="text-xs text-gray-400">{rev.date}</span>
                            </div>
                            <div className="flex items-center gap-1 mb-2">
                              {[...Array(5)].map((_, i) => (
                                <FaStar
                                  key={i}
                                  className={`${
                                    i < rev.rating ? 'text-yellow-400' : 'text-gray-200'
                                  } text-xs`}
                                />
                              ))}
                            </div>
                            <p className="text-sm text-gray-600 leading-relaxed">{rev.comment}</p>
                          </div>
                        ))}
                      </div>
                      <button className="mt-4 text-orange-500 font-semibold text-sm hover:text-orange-600 transition-colors flex items-center gap-1 group">
                        Read All Reviews
                        <FaArrowRight className="group-hover:translate-x-1 transition-transform" />
                      </button>
                    </div>
                  </div>
                )}
                {activeTab === 'faq' && (
                  <div className="animate-fadeIn">
                    <h4 className="font-semibold text-gray-800 mb-2">Frequently asked questions</h4>
                    <div className="space-y-3">
                      {faqs.map((faq, idx) => (
                        <div key={idx}>
                          <p className="text-sm font-medium text-gray-800">Q: {faq.q}</p>
                          <p className="text-sm text-gray-600">A: {faq.a}</p>
                        </div>
                      ))}
                    </div>
                  </div>
                )}
              </div>
            </div>
            <div className="mb-6">
              <h4 className="text-sm font-semibold text-gray-700 mb-2">Shop by Looks</h4>
              <div className="flex flex-wrap gap-2">
                {shopByLooks.map((tag) => (
                  <span key={tag} className="bg-gray-100 text-gray-700 px-3 py-1.5 rounded-full text-xs hover:bg-orange-100 cursor-pointer transition-colors">
                    {tag}
                  </span>
                ))}
              </div>
            </div>
            <div className="flex flex-col sm:flex-row gap-4">
              <button className="flex-1 bg-gradient-to-r from-gray-900 to-black text-white py-4 rounded-2xl font-black text-xl hover:from-orange-500 hover:to-orange-600 transition-all duration-500 shadow-xl hover:shadow-2xl active:scale-95 flex items-center justify-center gap-3 group">
                <FaHeart className="group-hover:scale-110 transition-transform" /> ADD TO CART
              </button>
              <button className="flex-1 bg-gradient-to-r from-orange-500 to-orange-600 text-white py-4 rounded-2xl font-black text-xl hover:from-orange-600 hover:to-orange-700 transition-all duration-500 shadow-xl hover:shadow-2xl active:scale-95 flex items-center justify-center gap-3 group">
                <FaLightning className="group-hover:scale-110 transition-transform" /> BUY NOW
              </button>
            </div>
          </div>
        </div>
      </div>

      <style jsx>{`
        @keyframes fadeIn {
          from { opacity: 0; transform: translateY(10px); }
          to { opacity: 1; transform: translateY(0); }
        }
        .animate-fadeIn {
          animation: fadeIn 0.6s ease-out;
        }
        .rotate-y-360 {
          transform: rotateY(360deg);
          transition: transform 2s ease-in-out;
        }
        @keyframes scan {
          0% { top: 0%; }
          50% { top: 100%; }
          100% { top: 0%; }
        }
        .animate-scan {
          position: absolute;
          animation: scan 1.5s infinite linear;
          box-shadow: 0 0 15px 5px rgba(249, 115, 22, 0.4);
        }
      `}</style>
    </div>
  );
};

export default ExclusiveCollection;